import { Requester } from './Requester';
import { IManifest } from '../types';

export const GetManifestContactById = async ({
    contactId,
    manifest
}: {
    contactId: string;
    manifest: string[];
}): Promise<IManifest | null> => {
    const stringManifest = JSON.stringify(manifest);

    try {
        const response = await Requester<IManifest>({
            // port: '8080',
            path: `contacts/${contactId}?manifest=${window.btoa(stringManifest)}`,
            method: 'GET'
        });

        return response ? (response as IManifest) : null;
        // return Object.hasOwn(response, '_id') ? (response as IContactRecord) : null;
    } catch (e) {
        console.error('Get manifest contact request failed');
        return Promise.reject(e);
    }
};
